import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `EntityIcon` and `WorkspaceAvatar` (spec M0-F7 §6.4).
 *
 * The sidebar tree draws a different glyph per entity kind and monday's `BoardKind`
 * (`private | public | share`) maps onto three of them; the workspace switcher and the
 * workspace home draw the same rounded-square avatar at three sizes.
 */
import { Icon } from '@vibe/core';
import { icons } from '../icons/index.js';
import { folderColor } from '../tokens/status-palette.js';
const ENTITY_GLYPH = {
    board: icons.board,
    board_private: icons.boardPrivate,
    board_share: icons.boardShareable,
    board_template: icons.boardTemplate,
    doc: icons.doc,
    dashboard: icons.dashboard,
    folder: icons.folder,
    workspace: icons.workspace,
};
/** `BoardKind` → the tree glyph, per §8's one-directional mapping. */
export function boardEntityKind(kind) {
    if (kind === 'private')
        return 'board_private';
    if (kind === 'share')
        return 'board_share';
    return 'board';
}
export function EntityIcon({ kind, size = 16, color, className, 'data-testid': dataTestId, }) {
    const glyph = ENTITY_GLYPH[kind];
    return (_jsx("span", { className: ['ez-entity-icon', className].filter(Boolean).join(' '), "data-entity-kind": kind, "data-testid": dataTestId, style: { color: color ? folderColor(color) : undefined, width: size, height: size }, children: _jsx(Icon, { icon: glyph, size: size, ignoreFocusStyle: true }) }));
}
/** Stable per name, so a workspace keeps its colour across sessions without storing one. */
const DERIVED_COLORS = [
    'done_green',
    'bright_blue',
    'working_orange',
    'dark_purple',
    'sofia_pink',
    'aquamarine',
    'royal',
    'stuck_red',
];
function derivedColor(name) {
    let hash = 0;
    for (let index = 0; index < name.length; index += 1)
        hash = (hash * 31 + name.charCodeAt(index)) >>> 0;
    return DERIVED_COLORS[hash % DERIVED_COLORS.length];
}
/** The rounded square with the workspace's initial, exactly the shape the switcher shows. */
export function WorkspaceAvatar({ name, color, size = 24, className, 'data-testid': dataTestId, }) {
    const background = folderColor(color ?? derivedColor(name));
    const initial = (name.trim()[0] ?? '?').toUpperCase();
    return (_jsx("span", { "aria-hidden": "true", className: ['ez-workspace-avatar', className].filter(Boolean).join(' '), "data-testid": dataTestId, style: {
            width: size,
            height: size,
            background,
            // P-039: the workspace home's avatar is 100 × 100 with radius **20** and a 52 px
            // initial (`[c:workspace-home]`, measured); the small sizes are unchanged.
            borderRadius: size >= 96 ? 20 : size >= 40 ? 10 : 6,
            fontSize: Math.round(size * (size >= 96 ? 0.52 : 0.5)),
        }, children: initial }));
}
//# sourceMappingURL=entities.js.map